import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRepublicOfTheCongo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_2026)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M6.50488 22.6708L15.3204 15.3204L22.6708 6.50491C21.528 4.29016 19.7159 2.47709 17.502 1.33282L8.6795 8.67958L1.33284 17.502C2.47701 19.716 4.29009 21.528 6.50488 22.6708Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M20.4856 20.4856C24.2715 16.6997 24.9983 11.0139 22.6675 6.49768L6.49766 22.6674C11.0139 24.9983 16.6997 24.2715 20.4856 20.4856Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.51435 3.51436C-0.271552 7.30026 -0.998301 12.9861 1.33246 17.5023L17.5023 1.33252C12.9861 -0.998336 7.30025 -0.271493 3.51435 3.51436Z",
				fill: "#6DA544"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_2026",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgRepublicOfTheCongo;
